import { useEffect, useRef } from 'react';
import { useYMaps } from '@pbe/react-yandex-maps';
import { Location } from './useGetLocations';

export function useYamap({
  startLocation,
  endLocation,
  setTime,
  setLength,
}: {
  startLocation: Location;
  endLocation: Location;
  setTime: (time: number) => void;
  setLength: (length: number) => void;
}) {
  const mapRef = useRef<ymaps.multiRouter.MultiRoute | null>(null);
  const ymaps = useYMaps(['Map', 'route', 'multiRouter.MultiRoute']);

  const handleOrderSumm = ({
    newStartLocation,
    newEndLocation,
  }: {
    newStartLocation?: Location;
    newEndLocation?: Location;
  } = {}) => {
    if (!ymaps || !startLocation?.lat || !endLocation?.lat) {
      return;
    }

    const routeStartLocation = [
      newStartLocation?.lat || startLocation.lat,
      newStartLocation?.lng || startLocation.lng,
    ];
    const routeEndLocation = [
      newEndLocation?.lat || endLocation.lat,
      newEndLocation?.lng || endLocation.lng,
    ];
    const multiRoute = new ymaps.multiRouter.MultiRoute(
      {
        referencePoints: [routeStartLocation, routeEndLocation],
        params: {
          routingMode: 'auto',
        },
      },
      {
        boundsAutoApply: true,
      }
    );

    mapRef.current = multiRoute;

    multiRoute.model.events.add('requestsuccess', () => {
      const activeRoute = multiRoute.getActiveRoute();
      if (activeRoute) {
        // Расстояние в метрах
        const distance = activeRoute.properties.get('distance', { value: 0 });
        // Время в пути в секундах
        const time = activeRoute.properties.get('duration', { value: 0 });
        // @ts-ignore
        setTime(Math.ceil(time.value / 60));
        // @ts-ignore
        setLength(Math.ceil(distance.value / 1000));
      }
    });
  };

  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current = null;
      }
    };
  }, []);

  return { handleOrderSumm };
}
